<ng-container *ngIf="serverError">
  <div class="modal-header">
    <h4 class="modal-title">Server Error: {{ serverError }}</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</ng-container>

<ng-container *ngIf="!serverError">

  <div class="modal-header">
    <h4 class="modal-title">Remove Time Tracking Role</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <p>
      Are you sure you want to remove <b style="color:black">{{ role.name }}</b>? This action cannot be undone.
    </p>
    <p>
      This role will no longer be available when clocking in staff, but will still be reflected in past time sheets.
    </p>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-secondary"
            (click)="activeModal.close()">
      Cancel
    </button>
    <button class="btn btn-danger"
            (click)="handleRemove()"
            *ngIf="!loadingRemove">
      Remove
    </button>
    <button type="button" class="btn btn-danger disabled" disabled
            *ngIf="loadingRemove">
      Loading...
    </button>
  </div>

</ng-container>
